import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import service from '../service';
import type { RegistrationCodeUsage } from '../types/registrationCode';
import { inviteCodeQueryKeys } from './useInviteCodes';

type UseInviteCodeUsageParams = {
  id: string;
  enabled?: boolean;
};

export function useInviteCodeUsage({
  id,
  enabled = true,
}: UseInviteCodeUsageParams): UseQueryResult<RegistrationCodeUsage, Error> {
  return useQuery<RegistrationCodeUsage, Error>({
    queryKey: inviteCodeQueryKeys.usage(id),
    enabled: enabled && !!id,
    queryFn: async () => service.getInviteCodeUsage(id),
  });
}
